module.exports = __webpack_public_path__ + "img/img6.c345844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img6.png
// module id = 270
// module chunks = 0